// Login Routes
export const LOGIN = '/'
export const LOGIN_2 = '/login'
export const LOGIN_SEARCH_REPORT_ID = '/search/datastudio/report:id?'
export const LOGIN_URL_DATASTUDIO = '/datastudio'
export const LOGIN_RECOVER = '/credenciales/recuperacion:query?'
export const LOGIN_EMAIL = '/email'

// slideBar routes
export const HOME = '/home'
export const POLYGONS_ZONE = '/polygons/zone'
export const POLYGONS_TERRITORIES = '/polygons/territories'
export const POLYGONS_BOSSES = '/polygons/bosses'
export const POLYGONS_MANAGERS = '/polygons/managers'
export const POLYGONS_MAPS = '/polygons/maps'
export const POLYGONS_BUDGETS = '/polygons/budgets'
export const POLYGONS_CONSOLIDATED = '/polygons/consolidated'
export const MAESTRO_SEGMENTATION = '/maestro/segmentation'
export const MAESTRO_SEGMENTATION4W = '/maestro/segmentation4w'
export const MAESTRO_PRICES = '/maestro/prices'
export const MAESTRO_LINES = '/maestro/lines'
export const MAESTRO_PROMOTIONS = '/maestro/promotion'
export const MAESTRO_PROJECTIONS = '/maestro/projections'
export const MAESTRO_BILLNG_CLASS = '/maestro/billingclass'
export const MAESTRO_LAUNCH = '/maestro/launch'
export const MAESTRO_LAUNCH_HIGH = '/maestro/launch_high'
export const MAESTRO_INDICATORS = '/maestro/indicators'
export const MAESTRO_M2 = '/maestro/m2'
export const ADMIN_USERS = '/adminusers'
export const ADMIN_USERS_PASSWORD = '/adminusers/password'
export const ADMIN_USERS_CREATOR = '/adminusers/creator'
export const ADMIN_USERS_PERMITS = '/adminusers/permits'
export const ADMIN_USERS_REPORTS = '/admin/reports'
export const ADMIN_USERS_REPORTS_REQUEST = '/admin/request'
export const ADMIN_USERS_PERMISSION = '/admin/reports/permission'
export const ADMIN_USERS_INVENTORY = '/adminusers_inventory'
export const ADMIN_USERS_CREATOR_INVENTORY = '/adminusers_inventory/creator'
export const ADMIN_USERS_DESTINATERIE =
  '/adminusers_adminusers_inventory/destinatario'
export const ADMIN_USERS_FONTS = '/admin/fonts'
export const REPORTS_PROVIDERS = '/reports/providers'
export const REPORTS_DATASTUDIO = '/reports/datastudio'
export const REPORTS_DATASTUDIO_QUERY = '/reports/datastudio/report'
export const REPORTS_MOBILITY = '/reports/mobility'
export const REPORTS_BOARD = '/reports/board'
export const REPORTS_BOARD_COMMERCIAL = '/reports/board/commercial/:id?'
export const REPORTS_DOCUMENTS = '/search/documents'
export const REPORTS_PQRS = '/search/pqrs_historico'
export const REPORTS_HELP = '/help'
export const REPORTS_GLUKY = '/gluky'
export const REPORTS_GLUKY_REJECT = '/gluky_reject'
export const INSIDE_YOUTUBE = '/insigth/youtube'
export const INSIDE_DETAIL = '/insigth/youtube/detail'
export const INSIDE_SALES_MANAGO = '/insigth/salesmanago'
export const MAP_APP = '/insigth/map_app'
export const MAP_VALUE = '/insigth/value_map'
export const MAP_VALUE_DETAIL = '/insigth/value_map/detail'
export const INSIDELEAD = '/leads'
export const INSIDELEAD_SOCIOS = '/leads_establecimientos'
export const INSIDELEAD_SOCIOS_TVS = '/leads_establecimientos_tvs'
export const INSIDELEAD_KPI = '/leads_kpis'
export const INSIDELEAD_KPI_TVS = '/leads_kpis_tvs'
export const INSIDELEAD_CAMPANA = '/leads_campanas'
export const INSIDELEAD_VEHICULO = '/leads_vehiculos'
export const INSIDELEAD_DISTRIBUCION = '/leads_distribucion'
export const REQUEST_REPORTS = '/reports/request'
export const REQUEST_PERMISSIONS = '/reports/requestPermissions'
export const ADMIN_REQUEST_PERMISSIONS = '/reports/AdminRequestPermissions'
export const MAP_BEACON = '/insigth/beacon_map'
export const INSIGHT = '/insight_factory/insight/:id'
export const INSIGHT_FACTORY = '/insight_factory'
export const INSIGHT_USERS = '/insight_factory/users'
export const INSIGHT_NEW_ENTRIES = '/insight_factory/new_entries'
export const INSIGHT_ENTRIES_QUEUE = '/insight_factory_entries_queue'
export const INSIGHT_TEST_ACCEPT = '/insight_factory_test_accept'
export const INSIGHT_PROGRESS = '/insight_factory_progress'
export const INSIGHT_QUESTIONS = '/insight_factory/questions/:id'
export const INSIGHT_DETAILS = '/insight_factory/details/:id'
export const INSIGHT_CHANGES = '/insight_factory/changes'
export const POSTVENTA_CSA = '/postventa'
export const MOTOMAX_FINDER = '/motomax_finder'
export const CHANNELS = '/channels'
export const STOCKTAKING_BEACONS = '/stocktaking_beacons'
export const SPARE_PARTS = '/spare_parts'
export const BUSQUEDA = '/busqueda'
export const GVC_JEFES = '/gvc_partners'
export const GVC_CONFIG = '/gvc_config'
export const GVC_INDICATORS = '/gvc_indicators'
export const GVC_ACTIONS = '/gvc_actions'
export const TRAKKU_EMAILS = '/trakku_emails'
export const GDC_HOME = '/gdv_home'
export const GDC_PDF = '/gdv_home/generar_pdf'
export const GDC_HOME_DISCOVER = '/gdv_home/discover'
export const GDC_HOME_RUTE = '/gdv_home/rute'
export const SNOP_CONFIG_USERS = '/snop_config_usuarios'
export const SOSTENIBILIDAD_INDICADOR = '/sostenibilidad_indicador'
export const SOSTENIBILIDAD_BATERIAS = '/sostenibilidad_baterias'
export const SOSTENIBILIDAD_LLANTAS = '/sostenibilidad_llantas'
export const SOSTENIBILIDAD_ENERGIA = '/sostenibilidad_energia'
export const SOSTENIBILIDAD_GAS = '/sostenibilidad_gas'
export const SOSTENIBILIDAD_AGUA = '/sostenibilidad_agua'
export const SOSTENIBILIDAD_RESIDUOS = '/sostenibilidad_residuos'
export const SOSTENIBILIDAD_USUARIOS = '/sostenibilidad_usuarios'
export const RUTA_AUTECO_DASHBOARD = '/ruta-auteco/dashboard'
export const SOSTENIBILIDAD_ROLES = '/sostenibilidad_roles'
export const SOSTENIBILIDAD_CONFIG = '/sostenibilidad_config'

export const SNOP_CONFIG_MATERIALS = '/snop_config_materiales'
export const SNOP_GROUPS = '/snop_groups'
export const SNOP_HOME = '/snop_home'
export const LUCIA_PAYMENT = '/facturacion'
export const CONTROL_DISPONIBILIDAD = '/control/disponibilidad'
export const CONTROL_FILL_RATE = '/control/fill_rate'
export const CONTROL_NS_PROOVEDOR_RATE = '/control/ns_proovedor'
export const CONTROL_DIAS_INVENTARIO = '/control/dias_inventario'
export const COMERCIAL_MERCADO = '/comercial/mercado'

export const TOM_CONFIG_USERS = '/tom_config_usuarios'
export const TOM_DASHBOARD = '/tom_dashboard'
export const TOM_GESTION = '/tom_gestion'

export const RUTA_PAGOS = '/ruta_pagos'
export const RUTA_VENDEDORES = '/ruta_vendedores'
export const RUTA_PRODUCTOS_PARTICIPANTES = '/ruta_productos_participantes'
export const RUTA_VENTAS = '/ruta_ventas'
export const RUTA_PRODUCTOS_RECOMPENSAS = '/ruta-auteco/productos-recompensas'

// Media Generator
export const MEDIA_GENERATOR_IMAGES = '/media-generator/images'
export const MEDIA_GENERATOR_VIDEOS = '/media-generator/videos'

// Nitro Pixel Pro
export const NITROPIXEL_PRO_HOME = '/nitropixel-pro/home'
export const NITROPIXEL_PRO_USUARIOS = '/nitropixel-pro/usuarios'
export const NITROPIXEL_PRO_INSTRUCCIONES_AGENTE = '/nitropixel-pro/instrucciones-agente'
export const NITROPIXEL_PRO_LIBRERIA = '/nitropixel-pro/libreria'
export const NITROPIXEL_PRO_MODELOS_LORA = '/nitropixel-pro/modelos-lora'
export const NITROPIXEL_PRO_MODELOS_FUNDACIONALES = '/nitropixel-pro/modelos-fundacionales'
export const NITROPIXEL_PRO_PROYECTOS = '/nitropixel-pro/proyectos'
export const NITROPIXEL_PRO_GENERACION = '/nitropixel-pro/generacion'
export const NITROPIXEL_PRO_GENERADOR = '/nitropixel-pro/generador'

// Módulo de compras
export const COMPRAS_CONFIG_USUARIOS = '/compras/config-usuarios'
export const COMPRAS_LEADTIME = '/compras/leadtime'
export const COMPRAS_COMPRA = '/compras/compra'
export const COMPRAS_CONFIG_MODELOS = '/compras/config-modelos'
export const COMPRAS_ADMIN_MODELOS = '/compras/admin-modelos'
export const COMPRAS_DESVIACION_COMBINADA = '/compras/desviacion-combinada'
export const COMPRAS_GRAFICO_SELL_IN = '/compras/grafico-sell-in'

export const AXIOMA_VALIDADORES = '/axioma/validadores'
export const AXIOMA_BOVEDA_DOCS = '/boveda-docs'
export const AXIOMA_BASCULAS = '/basculas'
export const AXIOMA_JERARQUIAS = '/axioma/jerarquias'
export const AXIOMA_AUDITOR = '/axioma/auditor'
export const AXIOMA_AXIOMER = '/axioma/axiomer'
export const AXIOMA_REEMPLAZANTES = '/axioma/reemplazantes'
export const AXIOMA_ESPECIFICACIONES = '/axioma/especificaciones'
export const AXIOMA_ESCANER = '/axioma/escaner'

// Ruta Segura
export const RUTA_SEGURA_RUTAS = '/ruta-segura/rutas'
export const RUTA_SEGURA_USUARIOS = '/ruta-segura/usuarios'

// Centralizador de Precios y Promos
export const PRECIOS_CENTRALIZADOR = '/precios/centralizador'
export const PRECIOS_LISTA = '/precios/lista-socios'

// Huella (sello "Esta moto tiene mi huella")
export const HUELLA = '/huella'
